import 'css-chunksrc/feature/seat-assignment/CheckItemSeatSelectionCTA.module.scss';export default {
  "textIcon": "CheckItemSeatSelectionCTA_textIcon"
};